import { render, staticRenderFns } from "./benfTabs.vue?vue&type=template&id=596db8a3"
import script from "./benfTabs.vue?vue&type=script&lang=js"
export * from "./benfTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports